
export interface VoiceTraitOption {
  readonly value: string;
  readonly label: string;
}

export const VOICE_GENDERS: readonly VoiceTraitOption[] = [
  { value: 'male', label: 'Мужской' },
  { value: 'female', label: 'Женский' },
  { value: 'neutral', label: 'Нейтральный' },
];

export const VOICE_AGES: readonly VoiceTraitOption[] = [
  { value: 'young', label: 'Молодой' },
  { value: 'middle_aged', label: 'Средний' },
  { value: 'old', label: 'Пожилой' },
];

export const VOICE_PURPOSES: readonly VoiceTraitOption[] = [
  { value: 'narrative_story', label: 'Начитка' },
  { value: 'conversational', label: 'Разговорный' },
  { value: 'informative_educational', label: 'Обучающий' },
  { value: 'social_media', label: 'Соцсети' },
  { value: 'advertisement', label: 'Реклама' },
  { value: 'entertainment_tv', label: 'Развлекательный' },
  { value: 'characters_animation', label: 'Персонажи' },
  { value: 'news', label: 'Новости' },
];

const VOICE_ACCENTS: Readonly<Record<string, string>> = {
  american: 'американский',
  british: 'британский',
  standard: 'обычный',
  australian: 'австралийский',
  indian: 'индийский',
  irish: 'ирландский',
  canadian: 'канадский',
  european: 'европейский',
};

// провайдер пишет одно и то же значение по-разному: middle_aged и middle-aged,
// Latin American и latin american
function normalize(value: string): string {
  return value.trim().toLowerCase().replace(/[\s-]+/g, '_');
}

function fromOptions(
  options: readonly VoiceTraitOption[],
  value: string | null | undefined,
): string | null {
  const raw = value?.trim();
  if (!raw) return null;
  const key = normalize(raw);
  return options.find((item) => item.value === key)?.label ?? raw;
}

export function genderLabel(value: string | null | undefined): string | null {
  return fromOptions(VOICE_GENDERS, value);
}

export function ageLabel(value: string | null | undefined): string | null {
  return fromOptions(VOICE_AGES, value);
}

export function purposeLabel(value: string | null | undefined): string | null {
  return fromOptions(VOICE_PURPOSES, value);
}

export function accentLabel(value: string | null | undefined): string | null {
  const raw = value?.trim();
  if (!raw) return null;
  return VOICE_ACCENTS[normalize(raw)] ?? raw;
}

export function traitLine(parts: readonly (string | null)[]): string {
  return parts.filter((part): part is string => Boolean(part)).join(' · ');
}
